import axios from '../../utils/axios';

export default function fetchLGCollectionsCount(adminId, params = {}) {
    return (
        axios.get(`/admin/${adminId}/allLGCollectionsCount`,  {params} )
    )
}
